import { noop } from 'lodash';
import { watchEffect, WatchStopHandle } from 'vue';
import { RouteLocationNormalized, Router, RouteRecordNormalized } from 'vue-router';
import i18n from '../../i18n';

let unwatch: WatchStopHandle = noop;

export default function setupTitleGuard(router: Router): void {
  router.afterEach((to) => {
    unwatch();
    unwatch = watchEffect(() => {
      const pageTitle = resolveTitle(to);
      const appTitle = i18n.global.t('general.appName');
      document.title = pageTitle ? `${pageTitle} | ${appTitle}` : appTitle;
    });
  });
}

function resolveTitle(route: RouteLocationNormalized): string | undefined {
  const record = route.matched.findLast(r => r.meta.title);
  const value = record?.meta.title;
  if (typeof value === 'string') return i18n.global.t(value);
  if (typeof value === 'function') return value(aggregateProps(record!)) || undefined;
}

function aggregateProps(record: RouteRecordNormalized): Record<string, any> {
  return Object.fromEntries(Object.values(record.props).flatMap(Object.entries));
}